export default {
  meta: {
    title: $localize`:@@meta.referrals.title:Реферальная система → CSFAIL`,
    description: $localize`:@@meta.referrals.desc:Получай до 5% с каждого депозита. Создай своё сообщество, Делись своим уникальным реферальным кодом, играй и зарабатывай с друзьями!`
  }
};